<template>
    <newHome v-if="isNewVersion"></newHome>
    <home v-else></home>
</template>
<script>
import { mapGetters } from 'vuex';
import home from './home.vue';
import newHome from './newHome/layout.vue';

export default {
    components: {
        home,
        newHome,
    },
    computed: {
        ...mapGetters(['isNewVersion']),
    },
};
</script>
